import Video from "../../../../src/components/video.js";
import * as React from 'react';
export default {
  Video,
  React
};